<template>
<vue-markdown>
### 1. 订单背景色显示规则
* 白色表示正常订单
* 绿色表示已经发货的订单
* 黄色表示距离文件下载完毕大于48小时未发货的订单
* 红色表示距离文件下载完毕大于72小时未发货的订单
* 以上提及的时间不会将周日00:00-23:59:59这一区间纳入统计

### 2. 订单搜索的方法
下面的截图表示的是订单搜索的所有方法。
![搜索订单](/assets/docs/search-order.png)

目前可以使用如下参数搜索订单：
* 订单状态（其中未完成表示所有未发货的订单）
* 订单所属公司
* 订单使用的快递公司
* 内部/外部订单号（内部订单号公打印厂内部使用， 外部订单号为第三方公司提供的订单号）
* 产品代码（一般为英文字母和数字组成比如 Calendar-A5）
* 快递号
* 收件人手机号
* 收件人名称 （输入“李”， 可以查询所有收件人名字包含该字的订单）

### 3. 订单各列的含义
![订单详情](/assets/docs/orders-detail.png)

上图可以查看到如下信息：
  * 每个订单所属的公司
  * 内外部订单号
  * 订单产品类型
  * 订单状态
  * 包含多少册多少份。比如一个订单含上中下3册， 用户需要打印2份， 则表示为3册 X 2份。（非1册 X 1份都会红色高亮显示）
  * 订单操作的三个关键时间， 分别是查询得知第三方有新订单的时间（创建时间），订单pdf下载到本地的时间， 以及订单发货时间
  * 拼板的任务名称：
    * 如果一个产品包含内页和外页两种类型的文件， 那么一般会有两个任务
    * 如果订单拼板过一次， 且拼板任务被删除或者撤销过，那么打印任务上会有删除标记
  * 其他信息：
    * 快递公司、快递单号
    * 快递的物流信息（物流状态会定时刷新）， 鼠标移到物流状态上， 可以查看物流详情
    * 附件， 需要随订单一起寄送的附件
    * 用户/管理员的留言。其中用户的留言会被打印到快递单上


</vue-markdown>
</template>

<script>
import VueMarkdown from 'vue-markdown'

export default {
  name: 'help-search-orders',
  components: {
    'vue-markdown': VueMarkdown
  }
}
</script>